// === Sinomarin Аптечная Консультация — Полный сценарий с ветвлениями ===

export const PRODUCTS = [
  {
    id: 'baby',
    name: 'Синомарин Беби',
    subtitle: '0–5 лет',
    color: '#E8F4FD',
    accentColor: 'hsl(201, 82%, 35%)',
    icon: '👶',
    description: 'Мягкий изотонический спрей для новорождённых и малышей до 5 лет. Деликатно очищает нос без дискомфорта.',
    usage: '1–2 раза в день, 1 нажатие в каждую ноздрю',
    features: ['Изотоническая формула', 'Без консервантов', 'С рождения'],
    tag: 'Дети 0–5',
  },
  {
    id: 'kids',
    name: 'Синомарин Кидс',
    subtitle: '3–12 лет',
    color: '#E8F8F2',
    accentColor: 'hsl(174, 55%, 36%)',
    icon: '🧒',
    description: 'Слегка гипертоническая морская вода для активного очищения носовых ходов у детей.',
    usage: '2–3 раза в день, 1–2 нажатия',
    features: ['Гипертоническая 2.3%', 'Активное очищение', 'Для детей 3+'],
    tag: 'Дети 3–12',
  },
  {
    id: 'adults',
    name: 'Синомарин Взрослый',
    subtitle: '12+ лет',
    color: '#EDF4FF',
    accentColor: 'hsl(220, 70%, 45%)',
    icon: '💧',
    description: 'Классический гипертонический спрей для взрослых. Снимает отёк, облегчает дыхание, промывает слизистую.',
    usage: '2–3 раза в день, 1–2 нажатия',
    features: ['Гипертоническая 2.3%', '80+ минералов', 'Не вызывает привыкания'],
    tag: 'Взрослые',
  },
  {
    id: 'plus',
    name: 'Синомарин Плюс',
    subtitle: 'Интенсивный уход',
    color: '#F0F8FF',
    accentColor: 'hsl(201, 82%, 28%)',
    icon: '✨',
    description: 'Усиленная формула с водорослями Algomer™. Максимальная защита слизистой, антивоспалительный эффект. Идеал при хронических и аллергических ринитах.',
    usage: '2–4 раза в день, 1–2 нажатия',
    features: ['Algomer™ комплекс', 'Аллергический ринит', 'Защита слизистой'],
    tag: 'Плюс',
  },
  {
    id: 'allergy',
    name: 'Синомарин Аллергия',
    subtitle: 'При аллергии',
    color: '#FFF5F0',
    accentColor: 'hsl(20, 80%, 45%)',
    icon: '🌿',
    description: 'Специальная формула для промывания носа от аллергенов: пыльцы, пыли, шерсти животных.',
    usage: '3–4 раза в день или по потребности',
    features: ['Вымывает аллергены', 'Безопасен постоянно', 'Сезонная аллергия'],
    tag: 'Аллергия',
  },
];

export const SCENARIOS = {
  start: {
    id: 'start',
    scene: 1,
    patientEmotion: 'neutral',
    patientText: 'Здравствуйте! У меня и у ребёнка заложен нос уже несколько дней. Что-то посоветуете?',
    pharmacistHint: 'Выберите правильный первый вопрос провизора',
    choices: [
      {
        text: 'Сколько лет ребёнку?',
        score: 10,
        quality: 'correct',
        feedback: 'Отлично! Возраст ребёнка — ключевой вопрос, так как формула Синомарина подбирается по возрасту.',
        next: 'scene2_age_asked',
      },
      {
        text: 'Берите Синомарин — он всем помогает!',
        score: -5,
        quality: 'wrong',
        feedback: 'Ошибка. Без уточнения возраста ребёнка невозможно подобрать правильный продукт. Дети до 3 лет и взрослые используют разные формулы.',
        next: 'scene2_rushed',
      },
      {
        text: 'У вас есть температура?',
        score: 3,
        quality: 'neutral',
        feedback: 'Это полезный вопрос, но не самый приоритетный. Сначала нужно узнать возраст ребёнка для подбора продукта.',
        next: 'scene2_temp_asked',
      },
    ],
  },

  scene2_age_asked: {
    id: 'scene2_age_asked',
    scene: 2,
    patientEmotion: 'happy',
    patientText: 'Ребёнку 2,5 года, у него зелёные выделения из носа. Мне 34 года — у меня сухость и заложенность, без температуры.',
    pharmacistHint: 'Выберите оптимальную рекомендацию',
    choices: [
      {
        text: 'Для малыша — Синомарин Беби (до 5 лет). Вам — Синомарин Плюс для интенсивного промывания.',
        score: 15,
        quality: 'correct',
        feedback: 'Превосходно! Синомарин Беби — идеал для детей до 5 лет. Синомарин Плюс с Algomer™ — оптимален при сухости и заложенности у взрослых.',
        next: 'scene3_dosage',
      },
      {
        text: 'Возьмите один большой флакон — будет удобнее для всей семьи.',
        score: -10,
        quality: 'wrong',
        feedback: 'Серьёзная ошибка! Один флакон для всей семьи — гигиенически неприемлемо и неэффективно. Детям до 5 лет нужна специальная изотоническая формула.',
        next: 'scene3_dosage',
      },
      {
        text: 'Есть ли у кого-то аллергия на морепродукты?',
        score: 5,
        quality: 'neutral',
        feedback: 'Хороший уточняющий вопрос! Синомарин — натуральная морская вода, и это действительно стоит уточнить. Однако основная рекомендация по возрасту важнее.',
        next: 'scene3_dosage',
      },
    ],
  },

  scene2_rushed: {
    id: 'scene2_rushed',
    scene: 2,
    patientEmotion: 'confused',
    patientText: 'А... какой именно? Ребёнку 2 года. Мне подойдёт такой же?',
    pharmacistHint: 'Клиент сам задал правильный вопрос — подберите нужный продукт',
    choices: [
      {
        text: 'Для малыша до 5 лет — Синомарин Беби. Для вас — Синомарин Плюс или взрослый.',
        score: 10,
        quality: 'correct',
        feedback: 'Правильное исправление! Важно предложить разные продукты по возрасту.',
        next: 'scene3_dosage',
      },
      {
        text: 'Да, один подойдёт обоим.',
        score: -10,
        quality: 'wrong',
        feedback: 'Ошибка! Нельзя рекомендовать взрослый спрей малышу 2 лет.',
        next: 'scene3_dosage',
      },
      {
        text: 'Скажите: есть ли у вас аллергический или простудный насморк?',
        score: 5,
        quality: 'neutral',
        feedback: 'Полезное уточнение, но сначала нужно решить вопрос с возрастом ребёнка.',
        next: 'scene3_dosage',
      },
    ],
  },

  scene2_temp_asked: {
    id: 'scene2_temp_asked',
    scene: 2,
    patientEmotion: 'neutral',
    patientText: 'Температуры нет. Ребёнку 2 года. У него густые выделения. Мне 34 — заложенность.',
    pharmacistHint: 'Теперь подберите продукты по возрасту',
    choices: [
      {
        text: 'Синомарин Беби — для малыша, Синомарин Плюс — для вас.',
        score: 15,
        quality: 'correct',
        feedback: 'Верно! Правильная рекомендация по возрасту. В следующий раз начните с вопроса о возрасте.',
        next: 'scene3_dosage',
      },
      {
        text: 'Без температуры — можно попробовать сосудосуживающие капли.',
        score: -10,
        quality: 'wrong',
        feedback: 'Не верно. Сосудосуживающие вызывают привыкание. Синомарин — безопасная альтернатива без побочных эффектов.',
        next: 'scene3_dosage',
      },
      {
        text: 'Давайте уточним — как давно симптомы? Больше недели?',
        score: 5,
        quality: 'neutral',
        feedback: 'Это полезная информация для понимания ситуации.',
        next: 'scene3_dosage',
      },
    ],
  },

  scene3_dosage: {
    id: 'scene3_dosage',
    scene: 3,
    patientEmotion: 'interested',
    patientText: 'Хорошо, спасибо! А как правильно использовать эти спреи? И сколько раз в день?',
    pharmacistHint: 'Дайте корректные инструкции по применению',
    choices: [
      {
        text: 'Ребёнку: 1–2 раза в день, по 1 нажатию в каждую ноздрю. Вам: 2–3 раза в день, 1–2 нажатия. Перед едой или сном.',
        score: 15,
        quality: 'correct',
        feedback: 'Отличные инструкции! Конкретные рекомендации по дозировке помогают клиенту соблюдать режим применения.',
        next: 'scene4_upsell',
      },
      {
        text: 'Читайте инструкцию на упаковке — там всё написано.',
        score: -5,
        quality: 'wrong',
        feedback: 'Это снижает доверие клиента. Провизор должен давать консультацию устно — это и есть добавленная ценность аптеки.',
        next: 'scene4_upsell',
      },
      {
        text: 'Можно использовать так часто, как нужно — он абсолютно безопасный.',
        score: 5,
        quality: 'neutral',
        feedback: 'Верно, что Синомарин безопасен. Но конкретные рекомендации по частоте применения дают клиенту лучший результат.',
        next: 'scene4_upsell',
      },
    ],
  },

  scene4_upsell: {
    id: 'scene4_upsell',
    scene: 4,
    patientEmotion: 'happy',
    patientText: 'Спасибо! Последний вопрос — мы часто летаем в самолётах и ездим в горы. Можно ли там использовать Синомарин?',
    pharmacistHint: 'Используйте это для повышения ценности продукта',
    choices: [
      {
        text: 'Синомарин — идеальный выбор в дороге! Сухой воздух самолётов и гор пересушивает слизистую. Синомарин увлажняет её, снижает риск инфекций.',
        score: 15,
        quality: 'correct',
        feedback: 'Превосходно! Вы добавили ценность продукту и укрепили доверие. Клиент теперь видит дополнительную пользу.',
        next: 'result',
      },
      {
        text: 'Лучше не брать в горы — давление другое, может не сработать.',
        score: -10,
        quality: 'wrong',
        feedback: 'Неверно. Синомарин безопасен в любых условиях. Давление не влияет на его эффективность.',
        next: 'result',
      },
      {
        text: 'Да, можно использовать везде — он без ограничений.',
        score: 7,
        quality: 'neutral',
        feedback: 'Верно, но упустили шанс рассказать о дополнительной пользе для путешественников.',
        next: 'result',
      },
    ],
  },

  result: {
    id: 'result',
    scene: 5,
    isResult: true,
  },
};

export const MODULES = [
  {
    id: 1,
    title: 'Базовые знания',
    subtitle: 'О продукте Синомарин',
    icon: 'book',
    color: 'blue',
    duration: '5 мин',
    locked: false,
    completed: false,
    description: 'Состав, механизм действия, линейка продуктов',
  },
  {
    id: 2,
    title: 'Консультация',
    subtitle: 'Симуляция с пациентом',
    icon: 'chat',
    color: 'teal',
    duration: '3–5 мин',
    locked: false,
    completed: false,
    description: 'Практика диалога и рекомендации',
    isMain: true,
  },
  {
    id: 3,
    title: 'Линейка продуктов',
    subtitle: 'Все варианты Синомарин',
    icon: 'grid',
    color: 'indigo',
    duration: '4 мин',
    locked: false,
    completed: false,
    description: 'Разбор каждого продукта для конкретной ситуации',
  },
  {
    id: 4,
    title: 'Работа с возражениями',
    subtitle: 'Ответы на вопросы',
    icon: 'shield',
    color: 'orange',
    duration: '6 мин',
    locked: true,
    completed: false,
    description: 'Почему Синомарин лучше аналогов? Частые вопросы',
  },
  {
    id: 5,
    title: 'Средний чек',
    subtitle: 'Допродажа и upsell',
    icon: 'chart',
    color: 'purple',
    duration: '4 мин',
    locked: true,
    completed: false,
    description: 'Как увеличить средний чек через правильную рекомендацию',
  },
  {
    id: 6,
    title: 'Аллергический ринит',
    subtitle: 'Специальные сценарии',
    icon: 'leaf',
    color: 'green',
    duration: '5 мин',
    locked: true,
    completed: false,
    description: 'Сезонная и круглогодичная аллергия — рекомендации',
  },
];

export const MAX_SCORE = 55;

export function getScoreRating(score) {
  const percentage = (score / MAX_SCORE) * 100;
  if (percentage >= 80) return { label: 'Эксперт', emoji: '🏆', color: 'success' };
  if (percentage >= 55) return { label: 'Хорошо', emoji: '👍', color: 'primary' };
  if (percentage >= 30) return { label: 'Практикант', emoji: '📚', color: 'warning' };
  return { label: 'Изучить продукт', emoji: '💡', color: 'destructive' };
}
